"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeSelect = exports.localisedExerciseInstructions = exports.localisedExerciseTitle = exports.isSupportedInstructionsLanguage = exports.supportedInstructionsLanguages = void 0;
const _1 = require(".");
/** Keeping exercise instruction/title localization utils here instead of translations
 * so I don't need to import exercise types from here in translations (translations was
 * created so that hevy-web can import utils from shared without importing something from
 * that isn't allowed in Edge Runtime)
 */
exports.supportedInstructionsLanguages = [
    'en',
    'it',
    'de',
    'es',
    'fr',
    'ca',
    'pt_BR',
    'pt_PT',
];
const isSupportedInstructionsLanguage = (lang) => {
    return (0, _1.isInArray)(lang, exports.supportedInstructionsLanguages);
};
exports.isSupportedInstructionsLanguage = isSupportedInstructionsLanguage;
const localisedExerciseTitle = (locale, template) => {
    var _a;
    if (template.is_custom) {
        return template.title;
    }
    return ((_a = (0, exports.localeSelect)(locale, {
        en: template.title,
        ar: template.ar_title,
        ca: template.ca_title,
        es: template.es_title,
        de: template.de_title,
        fr: template.fr_title,
        hi: template.hi_title,
        it: template.it_title,
        pl: template.pl_title,
        pt_BR: template.pt_br_title,
        tr: template.tr_title,
        zh_CN: template.zh_cn_title,
        zh_TW: template.zh_tw_title,
        ru: template.ru_title,
        ja: template.ja_title,
        ko: template.ko_title,
    })) !== null && _a !== void 0 ? _a : template.title);
};
exports.localisedExerciseTitle = localisedExerciseTitle;
const localisedExerciseInstructions = (locale, exerciseTemplate) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (exerciseTemplate.is_custom) {
        return '';
    }
    return (0, exports.localeSelect)(locale, {
        en: (_b = (_a = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _a === void 0 ? void 0 : _a.en) !== null && _b !== void 0 ? _b : '',
        pt_PT: (_c = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _c === void 0 ? void 0 : _c.pt_PT,
        de: (_d = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _d === void 0 ? void 0 : _d.de,
        es: (_e = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _e === void 0 ? void 0 : _e.es,
        it: (_f = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _f === void 0 ? void 0 : _f.it,
        fr: (_g = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _g === void 0 ? void 0 : _g.fr,
        ca: (_h = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _h === void 0 ? void 0 : _h.ca,
        pt_BR: (_j = exerciseTemplate === null || exerciseTemplate === void 0 ? void 0 : exerciseTemplate.localised_instructions) === null || _j === void 0 ? void 0 : _j.pt_BR,
    });
};
exports.localisedExerciseInstructions = localisedExerciseInstructions;
const localeSelect = (locale, options) => {
    var _a;
    return (_a = options[locale]) !== null && _a !== void 0 ? _a : options.en;
};
exports.localeSelect = localeSelect;
